// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-modals-DeleteConfirmModals-module__modalContent__RuB2k";
export { _1 as "modalContent" }
